import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import DemoMeetingCard from '../../../../components/DemoMeetingCard'
import MeetingCard from '../../../../components/MeetingCard'
import TutorialMeetingCard from '../../../../components/TutorialMeetingCard'
import useTransition from '../../../../hooks/useTransition'
import TeamDashInsights from '../TeamDashInsights/TeamDashInsights'





const TeamDashActivityTab = (props) => {
  const {teamRef} = props
  const team = useFragment(
    graphql`
      fragment TeamDashActivityTab_team on Team {
        activeMeetings {
          id
          ...MeetingCard_meeting
        }
        insights {
          id
          ...TeamDashInsights_insights
        }
      }
    `,
    teamRef
  )

  const {activeMeetings, insights} = team
  const transitioningMeetings = useTransition(
    activeMeetings.map((meeting, displayIdx) => ({
      ...meeting,
      key: meeting.id,
      displayIdx
    }))
  )

  return (
    React.createElement('div', { className: "flex h-full w-full flex-1 flex-col overflow-auto pl-4"      ,}
      , React.createElement('div', { className: "flex flex-col pl-2"  ,}
        , React.createElement('h3', { className: "mb-0 text-base font-semibold"  ,}, "Open Meetings" )
        , transitioningMeetings.length === 0 && (
          React.createElement('p', { className: "my-2",}, "No meetings yet? You've come to the right place!"        )
        )
      )
      , React.createElement('div', { className: "flex w-full flex-wrap pr-4"   ,}
        , transitioningMeetings.length > 0 ? (
          transitioningMeetings.map((meeting) => {
            const {child} = meeting
            const {id, displayIdx} = child
            return (
              React.createElement(MeetingCard, {
                key: id,
                displayIdx: displayIdx,
                meeting: meeting.child,
                onTransitionEnd: meeting.onTransitionEnd,
                status: meeting.status,}
              )
            )
          })
        ) : (
          React.createElement(React.Fragment, null
            , React.createElement(DemoMeetingCard, null )
            , React.createElement(TutorialMeetingCard, { type: "retro",} )
            , React.createElement(TutorialMeetingCard, { type: "standup",} )
            , React.createElement(TutorialMeetingCard, { type: "poker",} )
          )
        )
      )
      , insights && (
        React.createElement('div', { className: "flex w-full flex-wrap pr-4"   ,}
          , React.createElement(TeamDashInsights, { teamInsightsRef: insights,} )
        )
      )
    )
  )
}
export default TeamDashActivityTab
